// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1SFNT","range":"MonthRangeSwitch_range__1e9-1","disabled":"MonthRangeSwitch_disabled__3-POn"};